import FormContainer, { TextInputType } from '../formContainer/FormContainer'
import PropTypes from 'prop-types'
import { regExAlphaComaHyphen } from '../../../utils/regExpressionsUtils'
import { useState } from 'react'
import { firstNameBlankErrorMessage, lastNameBlankErrorMessage, personalInformationErrorMessage } from '../constants/Validations'

export default function PersonalInformationSection( props ) {
    
    const [ firstName, setFirstName ] = useState( props.currentFirstName ? props.currentFirstName : '' )
    const [ lastName, setLastName ] = useState( props.currentLastName ? props.currentLastName : '' )
    const [ firstNameError, setFirstNameError ] = useState( null )
    const [ lastNameError, setLastNameError ] = useState( null )
    
    const handlePersonalInformationOnChange = ( e, isLastName ) => {
        isLastName ? setLastName(  e.target.value ) : setFirstName(  e.target.value )

        if( regExAlphaComaHyphen.test(  e.target.value ) ){
            isLastName ? setLastNameError( null )  : setFirstNameError( null ) 
        }
    }

    const handlePersonalInformationValid = ( e, isLastName ) => {
        e.target.value = e.target.value.trim()
        
        isLastName ? setLastName(  e.target.value ) : setFirstName(  e.target.value )
        isLastName ? props.setPersonalInformationValues(  firstName, e.target.value ) : props.setPersonalInformationValues(  e.target.value, lastName )

        if( e.target.value == '' ){
            isLastName ? setLastNameError( lastNameBlankErrorMessage )  : setFirstNameError( firstNameBlankErrorMessage )
            props.setPersonalInformationIsValid ( false )
            return
        }
        
        if( regExAlphaComaHyphen.test(  e.target.value ) ){
            isLastName ? setLastNameError( null )  : setFirstNameError( null )
            if( !firstNameError && !lastNameError )
                props.setPersonalInformationIsValid ( true )
        }
        else{
            isLastName ? setLastNameError( personalInformationErrorMessage )  : setFirstNameError( personalInformationErrorMessage )
            props.setPersonalInformationIsValid ( false )
        }
    }
    
    return (
        <FormContainer 
            formTitle = { props.tittle }
            formTitleAdaMsg = { props.tittle + ' section' }
            formTitleClassName = "c-form-intro c-form-intro--long"
            containerClassName = "c-form-container c-form-container--box c-form-container--box-row mb-5"
            formInputComponents = { [ 
                { 
                    ...props.personalInformationConfig,
                    value: firstName,
                    invalidText: firstNameError,
                    invalid: firstNameError ? true : false,
                    labelText: 'First Name',
                    id: 'FirstName',
                    type: 'text',
                    autoComplete: 'new-password',
                    maxLength: 25,
                    tabIndex: 0,
                    ariaLabel: 'Enter First Name field.',
                    visible: true,
                    inputType: TextInputType,
                    onBlur: ( e ) => handlePersonalInformationValid( e, false ),
                    onChange: ( e ) => handlePersonalInformationOnChange( e, false ),
                }, 
                {
                    ...props.personalInformationConfig,
                    value: lastName,
                    invalidText: lastNameError,
                    invalid: lastNameError ? true : false,
                    labelText: 'Last Name', 
                    id: 'LastName', 
                    type: 'text', 
                    autoComplete: 'new-password',
                    maxLength: 25,
                    tabIndex: 0,
                    ariaLabel: 'Enter Last Name field.',
                    visible: true,
                    inputType: TextInputType,
                    onBlur: ( e ) => handlePersonalInformationValid( e, true ),
                    onChange: ( e ) => handlePersonalInformationOnChange( e, true ),
                } 
            ] }
            notificationVisible = { false }
            showInputComponentsInColum = { false }
        >
        </FormContainer>
    )
}

PersonalInformationSection.propTypes = {
    firstNameConfig: PropTypes.instanceOf( Object ),
    lastNameConfig: PropTypes.instanceOf( Object ),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    tittle: PropTypes.string.isRequired,
    setPersonalInformationIsValid: PropTypes.func.isRequired,
    setPersonalInformationValues: PropTypes.func.isRequired,
    currentFirstName: PropTypes.string,
    currentLastName: PropTypes.string,
    personalInformationConfig: PropTypes.instanceOf( Object )
}